var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c(
        "div",
        { staticStyle: { height: "100%" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "100%" },
            attrs: {
              no: "3",
              "config-module": "150010",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c("airline-product-voyage-board-dialog", {
        attrs: {
          visible: _vm.voyageBoardDialog.visible,
          "row-data": _vm.voyageBoardDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.voyageBoardDialog, "visible", $event)
          },
          save: _vm.voyageBoardSaveHandle
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }